import apiUrl from '../../../constants'
import axios from 'axios'
import {
  Validator
} from 'vee-validate'
import DatePicker from 'vue2-datepicker'
import LocalTrip from './LocalTrip/index.vue';
import NetworkTrip from './NetworkTrip/index.vue';
// for Bond & Brooks Trip
import BondBrooksTrip from './BondBrooksTrip/index.vue';
//import LinehaulBikerTrip from './LinehaulBikerTrip/index.vue';
import NetworkLocalTrip from './NetworkLocalTrip/index.vue';

export default {
  name: 'trip-management',
  components: {
    DatePicker,
    'first': LocalTrip,
    'second': NetworkTrip,
     'third': BondBrooksTrip,
     'fourth': NetworkLocalTrip,
     //'fourth': LinehaulBikerTrip,
  },
  props: [],
  data() {
    return {
      currentTab: 'First',
      componentKey: 0,
      tabs: [{
          key: 'First',
          value: 'Local Trip'
        },
        {
          key: 'Second',
          value: 'Network Trip'
        },
        {
          key: 'Third',
          value: 'BrooksNBonds Trip'
        },
        // {
        //   key: 'Fourth',
        //   value: 'Linehaul Biker Trip'
        // }
        {
          key:'Fourth',
          value:'Network Local Trip'
        },
      ],
    }
  },
  computed: {
    // selects all checkbox's option
    currentTabComponent: function() {
      this.componentKey += 1
      return this.currentTab.toLowerCase()
    }
  },
  mounted() {},
  methods: {}
}



// WEBPACK FOOTER //
// ./src/views/components/TripManagement/TripManagement.js